export enum LOGIN_HELP {
    /**
     * @value Don’t know how to sign in ?
     */
    DONT_KNOW_HOW_TO_SIGN_IN = 'LOGIN_HELP.DONT_KNOW_HOW_TO_SIGN_IN',
    /**
     * @value laptop screenshot helper
     */
    LAPTOP_SCREENSHOT_HELPER = 'LOGIN_HELP.LAPTOP_SCREENSHOT_HELPER',
    /**
     * @value Link text shown on sign-in screen
     */
    LINK_TEXT_SHOWN_ON_SIGN_IN_SCREEN = 'LOGIN_HELP.LINK_TEXT_SHOWN_ON_SIGN_IN_SCREEN',
    /**
     * @value Enable « Don't known how to sign in? »
     */
    LOGIN_HELP_URL = 'ADMIN.MOBILE.LOGIN_HELP_URL',
    /**
     * @value Show link on sign-in screen
     */
    SHOW_LINK_ON_SIGN_IN_SCREEN = 'LOGIN_HELP.SHOW_LINK_ON_SIGN_IN_SCREEN',
    /**
     * @value Sign-in page
     */
    SIGN_IN_PAGE = 'LOGIN_HELP.SIGN_IN_PAGE',
}
